module.exports = __webpack_public_path__ + "82f8e23b5b6ef18f9d134b131c979291.svg";